import { useQuery } from '@tanstack/react-query';
import { API_BASE_URL, getAuthHeader } from '../../../utils/api';
import axios from 'axios';

// Configure axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

// Add auth header interceptor
api.interceptors.request.use(async (config) => {
  const headers = await getAuthHeader(config.method);
  config.headers = { ...config.headers, ...Object.fromEntries(headers.entries()) };
  return config;
});

const AUCTION_HOUSES_KEY = 'auction_houses';

export const useAuctionHouses = () => {
  return useQuery({
    queryKey: [AUCTION_HOUSES_KEY],
    queryFn: async () => {
      const { data } = await api.get('/contacts', {
        params: {
          contact_type: 'auction_house'
        }
      });
      return data;
    },
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
    retry: 2, // Retry failed requests up to 2 times
    refetchOnMount: true, // Ensure we have fresh data on mount
    refetchOnWindowFocus: false // Prevent refetch on window focus
  });
};
